import React from 'react';
import useStyles from './styles';
import Context from './context';
import Hero from './Hero';
import Intro from './Intro';
import Area from './Area';
import Grid from '@material-ui/core/Grid';
import Card from '../../front/Plans/Card';
import Business from './Business';
import Flow from './Flow';
import About from './About';
import Partner from './Partner';

const Container = ({ plans = [], businesses = [], isAuthenticated }) => {
  const classes = useStyles();

  return (
    <Context.Provider value={{ classes }}>
      <div className={classes.container} style={{ paddingBottom: 0 }}>
        <Hero />
      </div>
      <div className={classes.container}>
        <Intro />
      </div>
      <div className={classes.bgSecondary}>
        <div className={classes.container}>
          <div className={classes.innerContainer}>
            <Area plans={plans} businesses={businesses} />
            {plans.length > 0 && (
              <Grid container spacing={2} className={classes.plans}>
                {plans.map((plan, index) => (
                  <Grid item xs={6} sm={3} key={`jtb-plan${index}`}>
                    <Card {...plan} isAuthenticated={isAuthenticated} />
                  </Grid>
                ))}
              </Grid>
            )}
            {businesses.length > 0 && <Business businesses={businesses} />}
          </div>
        </div>
      </div>
      <div className={classes.container}>
        <div className={classes.innerContainer} style={{ paddingBottom: 0 }}>
          <Flow />
        </div>
      </div>
      <div className={classes.container}>
        <About />
        <Partner />
      </div>
    </Context.Provider>
  );
};

export default Container;
